import { render, staticRenderFns } from "./monday-oauth.page.vue?vue&type=template&id=c89d87c4&"
import script from "./monday-oauth.page.vue?vue&type=script&lang=js&"
export * from "./monday-oauth.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports